module.exports = __webpack_public_path__ + "img/destination-mekong.5728534d.png";